import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import CurrencyInputWrapper from 'components/form/currency_input_wrapper';

class CommissionPlanFormTier extends React.Component {
  static propTypes = {
    index: PropTypes.number.isRequired,
    readOnly: PropTypes.bool,
    tier: PropTypes.shape({
      brokerSplit: PropTypes.number,
      formattedFrom: PropTypes.string,
      to: PropTypes.number
    }).isRequired,
    unlimited: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  }

  handleChange = (event, _, value = parseFloat(event.target.value)) => {
    const changes = { [event.target.name]: value || null };
    this.props.onChange({ ...this.props.tier, ...changes }, this.props.index);
  }

  render() {
    return (
      <tr>
        <td className="text-right disabled" name="from">
          {this.props.tier.formattedFrom}
        </td>
        {this.renderToCell()}
        {this.renderBrokerSplitCell()}
      </tr>
    );
  }

  renderToCell() {
    const { readOnly, tier, unlimited } = this.props;
    const className = classNames({ disabled: unlimited || readOnly, 'text-right': unlimited });
    const input = unlimited ? <span name="unlimited-to-label">Unlimited</span> : (
      <CurrencyInputWrapper
        className="text-right"
        disabled={readOnly}
        name="to"
        precision={0}
        value={tier.to}
        onChangeEvent={this.handleChange}
      />
    );

    return <td className={className}>{input}</td>;
  }

  renderBrokerSplitCell() {
    const className = classNames({ disabled: this.props.readOnly });

    return (
      <td className={className}>
        <input
          className="text-right"
          disabled={this.props.readOnly}
          name="brokerSplit"
          type="number"
          value={this.props.tier.brokerSplit == null ? '' : this.props.tier.brokerSplit}
          onChange={this.handleChange}
        />
      </td>
    );
  }
}

export default CommissionPlanFormTier;
